"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageProvider = void 0;

var _consts = require("../core/consts");

var _util = require("./util");

const DEFAULT_SIZE = 150;

class ImageProvider {
  constructor(imageClient) {
    this._imageClient = imageClient;
  }

  get baseUrl() {
    return this._imageClient.baseUrl;
  }

  _getComponentUrl(modelOrImageId, component, size = DEFAULT_SIZE) {
    const model = (0, _util.ensureModelIsObject)(modelOrImageId);
    const {
      width,
      height
    } = constrainTo(model, size);
    return `${this._imageClient.getUrlTo(model)}?${component(height, width)}`;
  }

  getLabelUrl(modelOrImageId, size = DEFAULT_SIZE) {
    return this._getComponentUrl(modelOrImageId, label, size);
  }

  getThumbnailUrl(modelOrImageId, size = DEFAULT_SIZE) {
    return this._getComponentUrl(modelOrImageId, thumbnail, size);
  }

  getMacroUrl(modelOrImageId, size = DEFAULT_SIZE) {
    return this._getComponentUrl(modelOrImageId, macro, size);
  }

  _getComponentImage(modelOrImageId, component, size = DEFAULT_SIZE) {
    const model = (0, _util.ensureModelIsObject)(modelOrImageId);
    const {
      width,
      height
    } = constrainTo(model, size);
    return this._imageClient.getImageData(model, component(height, width));
  }

  getLabel(modelOrImageId, size = DEFAULT_SIZE) {
    return this._getComponentImage(modelOrImageId, label, size);
  }

  getThumbnail(modelOrImageId, size = DEFAULT_SIZE) {
    return this._getComponentImage(modelOrImageId, thumbnail, size);
  }

  getMacro(modelOrImageId, size = DEFAULT_SIZE) {
    return this._getComponentImage(modelOrImageId, macro, size);
  }

  getTileUrl(modelOrImageId, options) {
    const model = (0, _util.ensureModelIsObject)(modelOrImageId);
    return `${this._imageClient.getUrlTo(model)}?${formatTileOptions(options)}`;
  }

}

exports.ImageProvider = ImageProvider;

function formatTileOptions(options) {
  // YAGNI: The viewer has gotten along just fine without providing mode, focus, or mpp. Doing so for some reason causes
  //        the response tiles to be returned as tiff's instead of jpgs. Removing till needed, if ever.
  const {
    top,
    left,
    width,
    height,
    zoom,
    quality
  } = Object.assign({}, _consts.DEFAULT_OPTIONS, options);
  return [left, top, width, height, zoom, quality].join('+');
}

const componentFactory = zoom => (height = DEFAULT_SIZE, width = DEFAULT_SIZE) => formatTileOptions({
  height,
  width,
  zoom
});

const label = componentFactory(_consts.IMAGE_TYPES.LABEL);
const thumbnail = componentFactory(_consts.IMAGE_TYPES.THUMBNAIL);
const macro = componentFactory(_consts.IMAGE_TYPES.MACRO_CAMERA_IMAGE);

function constrainTo({
  width,
  height
}, size = DEFAULT_SIZE) {
  if (height && width) {
    const ratio = Math.min(size / width, size / height);
    width = width * ratio;
    height = height * ratio;
  } else {
    width = 0; // imageserver will resize

    height = size;
  }

  return {
    height,
    width
  };
}